'use strict';

angular.module(ApplicationConfiguration.applicationModuleName).controller('userPasswordChangeCtrl', function ($scope, $rootScope, $window, $state, $http, $filter, MessageService, model, User, Auth) {
	var vm = this;

	var $translate = $filter('translate');

	vm.model = model;

	angular.extend($scope.$parent.vm, {
		title: 'users.settings.titleMyProfile',
		insertUrl: null
	});

	$rootScope.laddaLoading = false;

	vm.changePassword = function () {

		$rootScope.laddaLoading = true;

		Auth.passwordChange({
			password: vm.model.newpassword,
			passwordConfirmation: vm.model.passwordConfirmation
		}, function (response) {
			MessageService.alertInfo("Senha alterada com sucesso!");

			$rootScope.laddaLoading = false;

		}, function (response) {
			MessageService.alertError(response.data);

			$rootScope.laddaLoading = false;
		});

	};
});